import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';

import * as helpers from './helpers';

export const useAppSubscription = (eventName, callback, params = {}) => {
    const paramsDeps = Object.values(params);

    useEffect(() => {
        const cb = (...args) => callback(params, ...args);

        dispatcher.on(eventName, cb);

        return () => {
            dispatcher.off(eventName, cb);
        };
        // `params` is always new, so we make this hack
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callback, eventName, ...paramsDeps]);
};

export const useAppNotifier = () => {
    const dispatch = useDispatch();

    useAppSubscription('session:reconnecting:notification', helpers.onServerReconnect, { dispatch, isReconnectVisible: true });
    useAppSubscription('server:socket:connect', helpers.onServerReconnect, { dispatch, isReconnectVisible: false });
};
